import LocalizedStrings, { LocalizedStringsMethods } from 'localized-strings';
import { ua } from "./strings_ua";
import { eng } from "./strings_eng";

const setLanguage = () => {
    if (process.env.REACT_APP_LANG === "ua") {
        return new LocalizedStrings({ ua }, options);
    } else {
        return new LocalizedStrings({ eng }, options);
    }
}

interface IStrings extends LocalizedStringsMethods {
    head: {
        emtpl: {
            title: string;
            metaDescription: string;
        }
        emtplSmartDrive: {
            title: string;
            metaDescription: string;
        }
        travel: {
            title: string;
            metaDescription: string;
        }
        greenCard: {
            title: string;
            metaDescription: string;
        },
        check: {
            title: string;
            metaDescription: string;
        }
    }
    travel: {
        header: {
            name: string
            description: string
        }
        forms: {
            preferCountry: string,
            importantInfo: string,
            importantInfoDesc1: string,
            importantInfoDesc2: string,
            importantInfoDesc3: string,
            importantInfoDesc4: string,
            importantInfoDesc5: string,
            startDate: string,
            endDate: string,
            startDateDesc1: string,
            startDateDesc2: string,
            startDateDesc3: string,
            startDateDesc4: string,
            startDateDesc5: string,
            endDateDesc1: string,
            endDateDesc2: string
        }
    }
    check: {
        header: {
            name: string
            description: string
        }
        footer: string
    }
    edit: string;
    touristData: string
    category: string;
    address: string;
    calculate: string;
    price: string;
    coverage: string;
    expiration: string;
    additional: string;
    sendAnotherMail: string;
    internationalPassport: string
    send: string;
    noAdditionalCoverage: string;
    learnMoreAboutVtpl: string;
    learnMoreAboutCasco: string;
    chooseFromSelected: string;
    getCode: string;
    and: string;
    code: string;
    controlCode: string;
    wrongCode: string;
    confirm: string;
    sendAgain: string;
    important: string;
    yes: string;
    congrats: string;
    toMainPage: string;
    toMainPageUrl: string;
    problem: string;
    areYouHere: string;
    details: string;

    optimalAdvertise1: string
    optimalAdvertise2: string
    optimalAdvertise2Tooltip: string
    optimalAdvertise3: string
    optimalAdvertise3Tooltip: string
    optimalAdvertise4: string
    optimalAdvertise4Tooltip: string
    optimalAdvertise5: string
    optimalAdvertise5Tooltip: string
    optimalAdvertise6: string
    optimalAdvertise6Tooltip: string
    optimalAdvertise7: string
    optimalAdvertise7Tooltip: string,
    optimalAdvertise8: string,
    optimalAdvertise9: string

    premiumAdvertise1: string
    premiumAdvertise1Tooltip: string
    premiumAdvertise2: string
    premiumAdvertise2Tooltip: string
    premiumAdvertise3: string
    premiumAdvertise3Tooltip: string
    premiumAdvertise4: string
    premiumAdvertise4Tooltip: string
    premiumAdvertise5: string
    premiumAdvertise5Tooltip: string

    classicAdvertise1: string
    classicAdvertise2: string
    classicAdvertise2Tooltip: string
    classicAdvertise3: string

    residentTrue: string
    residentFalse: string

    optimalAdvertiseTitle: string
    premiumAdvertiseTitle: string
    classicAdvertiseTitle: string

    learnMore: string

    whatIsInsuredSum: string
    insuredSum: string
    insuredSum2: string
    chooseYourProgram: string

    allWorld: string
    allWorldExceptCanada: string
    allWorldExceptUSACanadaIndonesiaThailandIndia: string
    allWorldExceptUSIndonesiaThailandUkraine: string
    europeCic: string

    calculateDetails: string
    checkDetails: string

    coveredZone: string

    touristCount: string
    travelPurpose: string
    covidAdv: string
    franchiseAdv: string
    activeAdv: string
    ageRange: string
    prohibitionCancelled: string
    ourAdv: string
    importantInfo: string
    policyTermsFile: string
    toCalculate: string
    findContract: string
    yourDetails: string
    timeFranchise: string

    livingAddress: string
    mobileNumber: string
    registrationDocument: string

    payerIsPerson: string

    travelAgree1_1: string
    travelAgree1_2: string
    travelAgree2_1: string
    travelAgree2_2: string

    program: string
    touristCountFull: string

    documentNumber: string
    addressFull: string

    insurerTourist: string
    tourist: string

    error: string;
    warning: string;
    errorDefaultMessage: string;
    emptyFieldErrorMessage: string;
    engineCapacityErrorMessage: string;
    ownerBirthDateErrorMessage: string;
    issueDateErrorMessage: string;
    incorrectEmailErrorMessage: string;
    tarifficationErrorMessage: string;
    reglamentErrorMessage1: string;
    reglamentErrorMessage2: string;
    reglamentErrorMessage2_GreenCard: string;
    reglamentErrorMessage3: string;
    smartDriveVehicleTypeMismatchError: string;
    identificationCodeError: string;
    unkwonwnError: string;
    crashFallbackTitle: string;
    crashFallbackDescription: string;

    noOptionsText: string;
    whatIsVin: string;
    whatIsAgreementPlace: string;
    agreementPlaceDescription: string;
    whatIsFranchise: string;
    verifyPhone: string;
    verifyDescription1: string;
    verifyDescription2: string;

    processingDialogTitle: string;
    processingDialogText: string;
    processingDialogText2: string;
    scenarioHeaderDescription: string;
    scenarioHeaderName: string;
    toolbarSearch: string;
    toolbarSearchShort: string;
    toolbarManual: string;
    toolbarNewClient: string;
    toolbarARXClient: string;
    toolbarCheck: string;
    menuQuestions: string;
    menuAbout: string;
    contacts: string;
    acceptButton: string;

    additionalCoverageVtpl: string;
    additionalCoverageCascoMessage: string;
    additionalCoverageCascoMessageSmartDrive: string;
    additionalCoverageVtplMessage: string;

    vehicle: string;
    vehicleData: string;
    vehicleTypeChoose: string;
    vehiclePlateNumberType: string;
    vehiclePlateNumberDescription: string;
    vehicleGroupB: string;
    vehicleGroupA: string;
    vehicleGroupC: string;
    vehicleGroupB5: string;
    vehicleGroupE: string;
    vehicleGroupD: string;
    vehicleShortGroupB: string;
    vehicleShortGroupB5: string;
    vehicleShortGroupC: string;
    vehicleType: string;
    vehicleTypeA1: string;
    vehicleTypeA2: string;
    vehicleTypeB1: string;
    vehicleTypeB2: string;
    vehicleTypeB3_1: string;
    vehicleTypeB3_2: string;
    vehicleTypeB4: string;
    vehicleTypeB5: string;
    vehicleTypeC1: string;
    vehicleTypeC2: string;
    vehicleTypeD1: string;
    vehicleTypeD2: string;
    vehicleTypeE: string;
    vehicleTypeF: string;
    brand: string;
    model: string;
    brandLong: string;
    categoryLong: string,
    modelLong: string;
    vehicleBrand: string;
    vehicleConstructionYear: string;
    vehicleConstructionYearLong: string;
    vehiclePlateNumber: string;
    vehiclePlateNumber2: string;
    vehicleEngineCapacity: string;
    vehicleEngineCapacity2: string;
    vehicleNextToDate: string;
    vehicleOtk: string;
    vehicleVin: string;
    vehicleVin2: string;
    vehicleVinDescription: string;
    engineType: string;
    engineTypeLbl: {
        diesel: string;
        gasoline: string;
        electric: string;
        hybrid: string;
        lpg: string;
    };
    engineCapacity: string;
    batteryCapacity: string;
    totalWeight: string;
    ownWeight: string;
    numberSeating: string;

    vehicleOwnerPartyType: string;
    vehicleOwnerName: string;
    vehicleOwnerAddress: string;
    vehicleOwnerBirthYear: string;
    vehicleOwnerBirthDate: string;
    vehicleOwnerTaxiUsage: string;
    vehicleOwnerRequiredTO: string;
    vehicleOwnerRegisterCity: string;
    vehicleEngineCapacityDetail: string;
    vehicleBatteryCapacity: string;
    vehicleTotalWeight: string;
    vehicleOwnWeight: string;
    vehicleNumberSeating: string;
    vehicleMinAgeDriver: string;
    vehicleMaxAgeDriver: string;
    vehicleMinAgeDriverErrorLower: string; 
    vehicleMinAgeDriverErrorUpper: string; 

    vehicleNotFound: string;
    vehicleNotFound1: string;
    vehicleNotFound2: string;
    vehicleNotFoundChangeNumber: string;

    infoMessages: string;

    documentTypePassport: string;
    documentTypeDriverLicense: string;
    documentTypeResidencePermit: string;
    registrationDocumentNumber: string;
    registrationDocumentIssueOrganization: string;
    registrationDocumentIssueDate: string;

    ownerIsInsured: string;
    ownerIsNotInsured: string;
    colorBlack: string;
    colorDarkBlue: string;
    colorGreen: string;
    colorBeige: string;
    colorRed: string;
    colorViolet: string;
    colorBrown: string;
    colorGray: string;
    colorOrange: string;
    colorYellow: string;
    colorWhite: string;

    tariffication: {
        checkData: {
            plateNumber: {
                title: string;
                text: string;
            },
            phoneNumber: {
                title: string;
                text: string;
            },
        };
    }

    tarifficationDescriptionHeader: string;
    tarifficationDescriptionHeaderSmartDrive: string;
    tarifficationDescriptionElement1: string;
    tarifficationDescriptionElement1SmartDrive: string;
    tarifficationDescriptionElement2: string;
    tarifficationDescriptionElement2SmartDrive: string;
    tarifficationDescriptionElement3SmartDrive: string;
    tarifficationDescriptionElement3: string;
    tarifficationTitle: string;
    tarifficationDescriptionHeaderGreenCard: string;
    tarifficationDescriptionGreenCardElement1: string;
    tarifficationDescriptionGreenCardElement2: string;

    contractStart: string;
    contractStartDate: string;
    contractEndDate: string;
    contractDuration: string;
    contractMtplMtsbu: string;
    contractGreenCardMtsbu: string;

    quotationDownload: string;
    quotationChoose: string;
    agreementCheckbox1: string;
    agreementCheckbox2: string;
    agreementCheckbox3: string;
    agreementCheckbox4: string;
    agreementCheckbox1in2025: string;
    agreementCheckbox2in2025: string;
    agreementCheckbox3in2025: string;
    agreementCheckbox4in2025: string;
    agreementLabel1: string;
    agreementLabel2: string;
    agreement1: string;
    agreement2: string;
    agreement3: string;
    agreement4: string;
    greenAgreementCheckbox: string;
    greenPeronalDataAgreement: string;
    greenFaxSignAgreement: string;

    agreementUserInformedPart1: string;
    agreementUserInformedPart2: string;
    agreementUserInformedPart3: string;

    partyPerson: string;
    partyOrganization: string;
    personalInfoData: string;
    personalInfoSurname: string;
    personalInfoName: string;
    personalInfoMiddleName: string;
    insuredFullName: string;
    insuredFullNameLong: string;
    personalInfoBirthDate: string;
    personalInfoLivingAddress: string;
    personalInfoLivingPhone: string;
    personalInfoResident: string;
    personalInfoResidentTooltip: string;
    personalInfoResidentCountry: string;
    personalInfoIpn: string;
    personalInfoRegistrationDocument: string;
    insured: string;
    insuredIpn: string;
    insuredBirthDate: string;
    insuredPhone: string;
    insuredEmail: string;
    insuredEmail2: string;
    insuredRegisterCity: string;
    interesting: string;
    antivirus: string;
    casco: string;
    family: string;
    wait: string;
    pay: string;
    yourOrder: string;
    firstPayment: string;
    popular: string;
    installmentAlternative: string;

    phoneWithDots: string

    franchise: string;
    franchise2: string;
    franchise3: string;
    noFranchise: string;
    franchiseDescription: string;
    chooseProgram: string;
    chooseOption: string;
    packageMtplName: string;
    packageOptionMtplName: string;
    packageOptionMtplText1: string;
    packageOptionMtplText2: string;
    packageOptionMtplText1in2025: string;
    packageOptionMtplText2in2025: string;
    packageOptionVtplName: string;
    packageCascoName: string;
    packageOptionCascoName: string;
    packageOptionCascoNameSmartDrive: string;
    packageVtplName: string;
    packageVtplDescription: string;
    packageOptionEmptyText: string;

    partyTypePerson: string;

    Kyiv: string;
    Ukraine: string
    KyivFull: string;
    Odesa: string;
    OdesaFull: string;
    Lviv: string;
    LvivFull: string;
    Kharkiv: string;
    KharkivFull: string;
    Dnipro: string;
    DniproFull: string;
    Zaporizhzhia: string;
    ZaporizhzhiaFull: string;
    China: string;
    Iran: string;

    durationMapDAYS_15: string;
    durationMapDAYS_21: string;
    durationMapMONTH_1: string;
    durationMapMONTHS_2: string;
    durationMapMONTHS_3: string;
    durationMapMONTHS_4: string;
    durationMapMONTHS_5: string;
    durationMapMONTHS_6: string;
    durationMapMONTHS_7: string;
    durationMapMONTHS_8: string;
    durationMapMONTHS_9: string;
    durationMapMONTHS_10: string;
    durationMapMONTHS_11: string;
    durationMapYEAR_1: string;

    preVerificationMessageReadMany: string;
    preVerificationMessageReadOne: string;
    preVerificationMessageSign: string;
    preVerificationMessageCasco: string;
    preVerificationMessageCascoSmartDrive: string;
    preVerificationMessageVtpl: string;
    preVerificationMessageTravel: string;

    stepsZero: string;
    stepsOne: string;
    stepsTwo: string;
    stepsThree: string;
    stepsFour: string;
    stepsFive: string;
    stepsSix: string;
    stepsBack: string;
    stepsNext: string;

    dgoInfo1: string;
    dgoInfo1in2025: string;
    dgoInfo2: string;
    dgoInfo3: string;
    dgoChoose: string;
    dgoDontChoose: string;

    successfulQuotationMTPL: string;
    successfulQuotationMTPL_VTPL: string;
    successfulQuotationMTPL_CASCO: string;
    successfulQuotationMTPL_VTPL_CASCO: string;
    successfulQuotation1: string;
    successfulQuotation2: string;
    successfulQuotation1a: string,
    successfulQuotation2a: string,
    successfulQuotation2b: string,
    successfullQuotationTravel: string,
    successfullQuotationGreenCard: string,

    fastCalculation: string;

    successfulQuotation: {
        promo: {
            casco: {
                title: string,
                description: string
            },
            antivirus: {
                title: string,
                description: string
            },
            family: {
                title: string,
                description: string
            }
        }
    },

    unsuccessfulPayment1: string;
    unsuccessfulPayment2: string;
    unsuccessfulPayment3: string;
    unsuccessfulPayment4: string;

    currencyUAH: string;

    smartDrive: {
        learnMoreAboutSmartDrive: string;
        packageBaseName: string;
        packageOptionCascoName: string;
        packageBasePlusName: string;
        vtplSumInsuredSelect: string;
        askPhone: {
            error: string;
            errorEmpty: string;
        }
    };
    secondPaymentInfo: string;

    datePlaceholder: string;

    indexHTML: {
        content: string,
        title: string
    }
    errorMessageDialog: {
        btnGood: string;
        btnDetails: string;
    }
    questionsPopup: {
        title: string;
        text1: string;
        text2: string;
        text3: string;
        text4: string;
        text5: string;
        text6: string;
        text7: string;
        text8: string;
        text9: string;
        text10: string;
        text11: string;
        text12: string;
        text13: string;
        text14: string;
        text15: string;
        text16: string;
        text17: string;
        text18: string;
        text19: string;
        text20: string;
        text21: string;
        text22: string;
        text23: string;
        text24: string;
        text25: string;
        text26: string;
        text27: string;
        text28: string;
        text29: string;
        text30: string;
        text31: string;
        text32: string;
        text33: string;
        text34: string;
        text35: string;
        text36: string;
        text37: string;
        text38: string;
        text39: string;
        text40: string;
        text41: string;
        text42: string,
        text43: string,
        text44: string,
        text45: string,
        text46: string,
        text47: string,
        text48: string,
        text49: string,
        text50: string,
        text51: string,
        text52: string,
        text53: string,
        text54: string,
        text55: string,
        text56: string,
        text57: string,
        text58: string,
        text59: string,
        text60: string,
        text61: string,
        text62: string,
        text63: string,
        text64: string,
        text65: string,
        text66: string,
        text67: string,
        text68: string,
        text69: string,
        text70: string,
        text71: string,
        text72: string
    }
    questionsPopupTravel: {
        title: string;
        text1: string;
        text2: string;
        text3: string;
        text4: string;
        text5: string;
        text6: string;
        text7: string;
        text8: string;
        text9: string;
        text10: string;
        text11: string;
        text12: string;
        text13: string;
        text14: string;
        text15: string;
        text16: string;
        text17: string;
        text18: string;
        text19: string;
        text20: string;
        text21: string;
        text22: string;
        text23: string;
        text24: string;
        text25: string;
        text26: string;
        text27: string;
        text28: string;
        text29: string;
        text30: string;
        text31: string;
        text32: string;
        text33: string;
        text34: string;
        text35: string;
        text36: string;
        text37: string;
        text38: string;
        text39: string;
        text40: string;
        text41: string;
        text42: string;
        text43: string;
        text44: string;
        text45: string;
        text46: string;
        text47: string;
        text48: string;
        text49: string;
        text50: string;
        text51: string;
        text52: string;
        text53: string;
        text54: string;
        text55: string;
        text56: string;
        text57: string;
        text58: string;
        text59: string;
        text60: string;
        text61: string;
        text62: string;
        text63: string;
        text64: string;
        text65: string;
        text66: string;
        text67: string;
        text68: string;
        text69: string;
        text70: string;
        text71: string;
        text72: string;
        text73: string;
        text74: string;
        text75: string;
        text76: string;
        text77: string;
        text78: string;
        text79: string;
        text80: string;
        text81: string;
        text82: string;
    }
    noSmartDriveDialog: {
        title: string;
        message: string;
        describtion: string;
        btnInstalled: string;
        btnWithout: string;
    }
    refs: {
        link: string;
        kontakty: string;
        avtocivilka: string;
        avtocivilka_all_inclusive: string;
        emtpl: string;
        mtsbu: string;
        smart_drive_apple: string;
        smart_drive_android: string;
        myarx_apple: string;
        myarx_android: string;
    }
    discount: {
        title: string;
        text1: string;
        text2: string;
        text3: string;
        text4: string;
        text5: string;
        text6: string;
        text7: string;
        text8: string;
        text9: string;
        text10: string;
        text11: string;
        text12: string;
        text13: string;
        text14: string;
        text15: string;
        text16: string;
        text17: string;
        text18: string;
        text19: string;
    }
    myARX: {
        text1: string;
        text2: string;
        text3: string;
        text4: string;
        text5: string;
        text6: string;
    }
    myARX2: {
        meta: string;
        title: string;
        items: string[];
    },
    phoneContact: string;
    infoView: {
        text1: string;
        text2: string;
        text3: string;
    }
    appAcceptedDlg: {
        text1: string;
        text2: string;
        text3: string;
        text4: string;
        text5: string;
    }
    buyMTPLDlg: {
        message: string;
        btnNext: string;
        btnCancel: string;
        btnHaveNot: string;
    },
    contactPhoneDlg: string;
    mtplPhoneNumberConfirmDlg: {
        text1: string;
        text2: string;
        text3: string;
        text4: string;
    }
    mtplPhoneNumberDlg: {
        text1: string;
        text2: string;
    }
    noDataByPhoneDlg: {
        text1: string;
        text2: string;
        text3: string;
    }
    mtlpReminderDialog: {
        title: string;
        subTitle: string;
        emailPlaceholder: string;
        datePlaceholder: string;
        dateLabel: string;
        subscribe: string;
        validation: {
            format: string;
            required: string;
            pastDateError: string;
        }
    }
    sdEnterNumberPhone: string;
    salesPackageInfo: {
        text1: string;
        text2: string;
        text3: string;
        text4: string;
    }
    understand: string;
    notChosen: string;
    booleanTrue: string;
    booleanFalse: string;
    loading: string;
    greenCardScrnarioHeader: string;
    greenTarifConfirmDialog: {
        title: string;
        changeParameters: string;
    }
    greenDataStep: {
        tooltipLatin: string;
        cyrillic: string;
        tooltipLatinLikeForeignPassport: string;
    }
    greenVerifyStep: {
        dataCheckHeader: string;
        coverageTerritory: string;
        price: string;
        validity: string;
        duration: string;
    }
    greenFinalStep: {
        title: string
        message: string
        messageEnd: string
        usefullInfo: {
            title: string
            memoLabel: string
            limitsLabel: string
        }
    },
    greenByNumberSearchDescription: string,
    greenCardDocumentNumber: string,
    mimeTypeLabels: {
        pdf: string
    },
    feedback: {
        title: string
        message: string
    },
    personalInfoDataSmartTooltipText: string;
    travelDialog: {
        text1: string,
        text2: string,
        text3: string,
        text4: string,
        text5: string,
        text6: string,
        text7: string
    },
    newOptionsWereAdded: string,
    actions: {
        clear: string,
        close: string,
        open: string
    },
    travelNameLabel: string,
    travelSurnameLabel: string,
    travelAddressLabel: string,
    notRequiredPassport: string,
    notRequiredPassportLabel: string
    validation: {
        required: string,
        maxLength: string,
    }
}

const options = {
    // pseudo: true, //Helper for finding string that is implemented. Developer's|Tester's use only
};

export const strings: IStrings = setLanguage();
